/* FELGER rev3-27-07 · Buscador con predictor del catalogo (punto 20).
 *
 * El cliente lo pidio asi: "debe tener un buscador donde se escriba el
 * producto que se busca y que arroje opciones para completar la busqueda
 * (predictor)".
 *
 * Usa /search/suggest.json, el endpoint nativo de Shopify: no hace falta un
 * indice propio ni una app. Devuelve productos ya filtrados por lo publicado
 * en el canal, asi que no puede sugerir algo que el visitante no pueda abrir.
 *
 * Deliberadamente NO muestra precios: el catalogo esta detras del price gate y
 * las sugerencias tienen que respetarlo igual que el resto del sitio.
 */
(function () {
  'use strict';

  var ESPERA_MS = 250;   // no disparar en cada tecla
  var MINIMO = 2;        // con 1 letra las sugerencias son ruido
  var MAXIMO = 8;

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function iniciar() {
    var input = document.querySelector('[data-fg-buscador]');
    var lista = document.querySelector('[data-fg-sugerencias]');
    var chips = document.querySelector('[data-fg-chips]');
    var anterior = document.querySelector('[data-fg-chips-prev]');
    var siguiente = document.querySelector('[data-fg-chips-next]');

    if (chips && anterior && siguiente) {
      var distancia = function () { return Math.max(260, Math.round(chips.clientWidth * 0.72)); };
      var actualizarBotones = function () {
        var maximo = chips.scrollWidth - chips.clientWidth - 2;
        anterior.disabled = chips.scrollLeft <= 2;
        siguiente.disabled = chips.scrollLeft >= maximo;
      };
      anterior.addEventListener('click', function () {
        chips.scrollBy({ left: -distancia(), behavior: 'smooth' });
      });
      siguiente.addEventListener('click', function () {
        chips.scrollBy({ left: distancia(), behavior: 'smooth' });
      });
      chips.addEventListener('scroll', actualizarBotones, { passive: true });
      window.addEventListener('resize', actualizarBotones);
      actualizarBotones();
    }

    if (!input || !lista) return;

    var indiceActivo = -1;
    var ultimaConsulta = '';

    function cerrar() {
      lista.hidden = true;
      lista.innerHTML = '';
      indiceActivo = -1;
      input.setAttribute('aria-expanded', 'false');
    }

    function pintar(productos) {
      lista.innerHTML = '';
      if (!productos.length) {
        var vacio = document.createElement('li');
        vacio.className = 'fg-sugerencia fg-sugerencia--vacia';
        vacio.textContent = 'Sin coincidencias. Prueba con otra palabra.';
        lista.appendChild(vacio);
        lista.hidden = false;
        return;
      }
      productos.slice(0, MAXIMO).forEach(function (p, i) {
        var li = document.createElement('li');
        li.className = 'fg-sugerencia';
        li.setAttribute('role', 'option');
        li.dataset.indice = String(i);

        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'fg-sugerencia__link';

        if (p.featured_image && p.featured_image.url) {
          var img = document.createElement('img');
          img.src = p.featured_image.url;
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'fg-sugerencia__img';
          a.appendChild(img);
        }

        var txt = document.createElement('span');
        txt.className = 'fg-sugerencia__txt';
        txt.textContent = p.title;
        a.appendChild(txt);

        if (p.type) {
          var linea = document.createElement('span');
          linea.className = 'fg-sugerencia__linea';
          linea.textContent = p.type;
          a.appendChild(linea);
        }

        li.appendChild(a);
        lista.appendChild(li);
      });
      lista.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function marcarActivo() {
      var items = lista.querySelectorAll('.fg-sugerencia');
      items.forEach(function (el, i) {
        el.classList.toggle('fg-sugerencia--activa', i === indiceActivo);
      });
    }

    var buscar = debounce(function (termino) {
      if (termino === ultimaConsulta) return;
      ultimaConsulta = termino;

      var url = '/search/suggest.json?q=' + encodeURIComponent(termino) +
        '&resources[type]=product&resources[limit]=' + MAXIMO +
        '&resources[options][unavailable_products]=show';

      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data) { cerrar(); return; }
          /* Si la persona siguio escribiendo, esta respuesta ya no sirve. */
          if (input.value.trim() !== termino) return;
          var productos = (data.resources &&
            data.resources.results &&
            data.resources.results.products) || [];
          pintar(productos);
        })
        .catch(function () { cerrar(); });
    }, ESPERA_MS);

    input.addEventListener('input', function () {
      var t = input.value.trim();
      if (t.length < MINIMO) { cerrar(); ultimaConsulta = ''; return; }
      buscar(t);
    });

    input.addEventListener('keydown', function (e) {
      var items = lista.querySelectorAll('.fg-sugerencia__link');
      if (e.key === 'Escape') { cerrar(); return; }
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        indiceActivo = (indiceActivo + 1) % items.length;
        marcarActivo();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        indiceActivo = indiceActivo <= 0 ? items.length - 1 : indiceActivo - 1;
        marcarActivo();
      } else if (e.key === 'Enter' && indiceActivo >= 0) {
        /* Solo interceptamos Enter si hay una sugerencia elegida; si no,
           dejamos que el form haga la busqueda completa. */
        e.preventDefault();
        items[indiceActivo].click();
      }
    });

    document.addEventListener('click', function (e) {
      if (!lista.contains(e.target) && e.target !== input) cerrar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
